// extracted by mini-css-extract-plugin
export default {"departmentIndex":"index_departmentIndex__W9IKb"};